import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';
import { TenantDTO } from '../domain/tenant';
import { CollaboratoreDTO } from '../domain/collaboratore';
import { DeviceDTO } from './device';

export class SoftwareDTO extends LogicalDeleteDTO {     //stesse cose e nomi del DTO del backend
    
    id: number;
    nome: string;
    tipologia: string;
    descrizione: string;
    signInOutDescription: string;
    modalitaAccesso: string;
    utilizzatori: string;
    trasferimentoDati: Boolean;
    devices: DeviceDTO[];  //associazione molti a molti

}